<template>
    <div class="top-menu-area">
        <span v-if="isLoggedIn">
            <base-snippet name="hello">
                Hello,
            </base-snippet>
            {{ getUserData.first_name }}
        </span>
        <a href="#">Links <i class="fa fa-caret-down"></i></a>
        <ul v-if="isLoggedIn" class="top-menu">
            <slot name="logged-in-menu"></slot>
            <li><a href="/my-account">My Account</a></li>
            <li ><a href="/logout">Log out</a></li>
        </ul>
        <ul v-else class="top-menu">
            <slot name="logged-out-menu"></slot>
            <li ><a :href="$snippet('login-url')+'?next='+here">
                Log in
            </a></li>
        </ul>
        <slot></slot>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import loginLinkRedirect from "vue-src/base/methods/loginLinkRedirect"

    export default {
        name: "account-nav",
        computed:{
            here(){
                return loginLinkRedirect()
            },
            ...mapGetters([
                'isLoggedIn',
                'getUserData',
            ]),
        },
    }
</script>



// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/top-level/account-nav.vue